import styled from 'styled-components';


export const Scroll = styled.div`
    overflow-x: auto !important;
    max-height: 500px;
    width: auto;
    margin-bottom: 34px
`;